"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { Button } from "@opensea/next-ui-kit";
import { AnimatedNumber, FlexColumn, formatAddress, SpaceBetween, TextOverflowTooltip } from "@opensea/ui-kit";
import { normalizeAddress } from "@opensea/utils";
import { useTranslations } from "next-intl";
import { useCallback } from "react";
import { useContextSelector } from "use-context-selector";
import { AsteriskText } from "@/components/profile/AsteriskText";
import { ProfileSettingsContext } from "@/components/profile/ProfileSettingsProvider";
import { useAuthenticatedCallback } from "@/hooks/use-authenticated-callback";
import { useAddress } from "@/hooks/wallet";
import { useLinkedWalletModalStore } from "@/stores/use-linked-wallet-modal-store";
import { AccountSwitcherItem, AccountSwitcherItemAvatar, AccountSwitcherItemContent, AccountSwitcherItemDescription, AccountSwitcherItemTitle } from "../top-nav/account-switcher/AccountSwitcherItem";
const MoreMenuTopAccountQuery = graphql(`
  query MoreMenuTopAccountQuery($address: Address!) {
    profilesByAccount(address: $address) {
      account {
        ... on Profile {
          username
          displayName
          address
          imageUrl
          portfolioSummary {
            estimatedTokenValue {
              usd
            }
          }
        }
      }
      profiles {
        ... on Profile {
          username
          displayName
          address
          imageUrl
          portfolioSummary {
            estimatedTokenValue {
              usd
            }
          }
        }
      }
    }
  }
`);
export function MoreMenuTopAccount() {
  const $ = _c(49);
  const address = useAddress();
  const {
    setIsLinkedWalletModalOpen
  } = useLinkedWalletModalStore();
  let t0;
  if ($[0] !== setIsLinkedWalletModalOpen) {
    t0 = () => {
      setIsLinkedWalletModalOpen(true);
    };
    $[0] = setIsLinkedWalletModalOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const openLinkedWalletModal = useAuthenticatedCallback(t0);
  let t1;
  if ($[2] !== address) {
    t1 = address ? normalizeAddress(address) : "";
    $[2] = address;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = {
      address: t1
    };
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = !address;
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      query: MoreMenuTopAccountQuery,
      variables: t2,
      pause: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      throwOnError: false
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const [t6] = useQuery(t4, t5);
  const {
    data
  } = t6;
  const t = useTranslations("MoreMenuTopAccount");
  const accountRaw = data?.profilesByAccount?.account;
  let t7;
  if ($[10] !== data?.profilesByAccount?.profiles) {
    t7 = data?.profilesByAccount?.profiles ?? [];
    $[10] = data?.profilesByAccount?.profiles;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const profiles = t7;
  const hideWalletWorth = useContextSelector(ProfileSettingsContext, _temp);
  let t8;
  if ($[12] !== hideWalletWorth) {
    t8 = value => {
      if (hideWalletWorth) {
        return <AsteriskText />;
      }
      return <AnimatedNumber display="usd" value={value} />;
    };
    $[12] = hideWalletWorth;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const renderUsdBalance = t8;
  if (!accountRaw || accountRaw.__typename !== "Profile") {
    return null;
  }
  const account = accountRaw;
  let normalizedAddress;
  let t9;
  let walletCountText;
  if ($[14] !== account.address || $[15] !== profiles || $[16] !== renderUsdBalance || $[17] !== t) {
    const validProfiles = profiles.filter(_temp2);
    const totalWalletCount = validProfiles.length;
    const profilesValue = validProfiles.reduce(_temp3, 0);
    const totalUsdValue = profilesValue;
    let t10;
    if ($[21] !== account.address) {
      t10 = normalizeAddress(account.address);
      $[21] = account.address;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    normalizedAddress = t10;
    walletCountText = t("walletsAndValue", {
      walletCount: totalWalletCount
    });
    t9 = renderUsdBalance(totalUsdValue);
    $[14] = account.address;
    $[15] = profiles;
    $[16] = renderUsdBalance;
    $[17] = t;
    $[18] = normalizedAddress;
    $[19] = t9;
    $[20] = walletCountText;
  } else {
    normalizedAddress = $[18];
    t9 = $[19];
    walletCountText = $[20];
  }
  const usdBalanceElement = t9;
  const t10 = `top-${normalizedAddress}`;
  const t11 = account.imageUrl || undefined;
  let t12;
  if ($[23] !== normalizedAddress || $[24] !== t11) {
    t12 = <AccountSwitcherItemAvatar seed={normalizedAddress} size={64} src={t11} />;
    $[23] = normalizedAddress;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== account.displayName || $[27] !== normalizedAddress) {
    t13 = account.displayName || formatAddress(normalizedAddress);
    $[26] = account.displayName;
    $[27] = normalizedAddress;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13) {
    t14 = <AccountSwitcherItemTitle size="md"><TextOverflowTooltip className="max-w-[120px]" disabled={true}>{t13}</TextOverflowTooltip></AccountSwitcherItemTitle>;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== usdBalanceElement || $[32] !== walletCountText) {
    t15 = <AccountSwitcherItemDescription>{walletCountText} • {usdBalanceElement}</AccountSwitcherItemDescription>;
    $[31] = usdBalanceElement;
    $[32] = walletCountText;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <FlexColumn>{t14}{t15}</FlexColumn>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t) {
    t17 = t("viewWallets");
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== openLinkedWalletModal || $[40] !== t17) {
    t18 = <Button onClick={openLinkedWalletModal} size="sm" variant="secondary">{t17}</Button>;
    $[39] = openLinkedWalletModal;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t16 || $[43] !== t18) {
    t19 = <AccountSwitcherItemContent><SpaceBetween className="w-full">{t16}{t18}</SpaceBetween></AccountSwitcherItemContent>;
    $[42] = t16;
    $[43] = t18;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  let t20;
  if ($[45] !== t10 || $[46] !== t12 || $[47] !== t19) {
    t20 = <AccountSwitcherItem className="h-20 rounded-xl border border-border-1 bg-bg-primary" key={t10}>{t12}{t19}</AccountSwitcherItem>;
    $[45] = t10;
    $[46] = t12;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  return t20;
}
function _temp3(sum, profile_0) {
  return sum + (profile_0.portfolioSummary?.estimatedTokenValue?.usd ?? 0);
}
function _temp2(profile) {
  return profile.__typename === "Profile";
}
function _temp(state) {
  return state.hideWalletWorth;
}